import { apiGetEventDetail } from "@/api/event";
export async function fetchNormalEventDetail( eventId: string ) {
    const [ ok, res ] = await apiGetEventDetail( eventId );

    if ( ok ) {
        const { guessList, ...eventData } = res.data || {};
        return {
            eventData: {
                eventNo: eventId,
                ...eventData,
            },
            guessList,
        };
    }
    return {
        eventData: null,
        guessList: null,
    };
}
